import { render, staticRenderFns } from "./infocomment.vue?vue&type=template&id=e8f093ac&"
import script from "./infocomment.vue?vue&type=script&lang=js&"
export * from "./infocomment.vue?vue&type=script&lang=js&"
import style0 from "./infocomment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports